import { Mapper } from 'src/base/mapper'
import { InvoiceTypeEntity } from 'src/data/entities/invoice.entity'
import { InvoiceTypeModel } from 'src/domain/models/invoice.model'

export class InvoiceMapper extends Mapper<InvoiceTypeEntity, InvoiceTypeModel> {
	mapFrom(param: InvoiceTypeEntity): InvoiceTypeModel {
		return {
			invoiceId: param.invoiceId,
			invoiceNumber: param.invoiceNumber,
			referenceId: param.referenceId,
			invoiceFrom: param.invoiceFrom,
			clientId: param.clientId,
			companyName: param.companyName,
			itemName: param.itemName,
			itemCode: param.itemCode,
			typeItem: param.typeItem,
			itemDescription: param.itemDescription,
			qty: param.qty,
			itemPrice: param.itemPrice,
			discount: param.discount,
			status: param.status,
			statusName: param.statusName,
			subscriptionId: param.subscriptionId,
			subscriptionName: param.subscriptionName,
			dateDue: param.dateDue,
			dateInvoice: param.dateInvoice,
			paymentTransactions: param.paymentTransactions,
			totalAmount: param.totalAmount,
			isPay: param.isPay,
			invoiceItems: param.invoiceItems,
			d365InvoiceNumber: param.d365InvoiceNumber,
			d365PackingSlipNumber: param.d365PackingSlipNumber,
			d365ReceiptNumber: param.d365ReceiptNumber,
			d365SalesOrderNumber: param.d365SalesOrderNumber,
		}
	}

	mapTo(param: InvoiceTypeModel): InvoiceTypeEntity {
		return {
			invoiceId: param.invoiceId,
			invoiceNumber: param.invoiceNumber,
			referenceId: param.referenceId,
			invoiceFrom: param.invoiceFrom,
			clientId: param.clientId,
			companyName: param.companyName,
			taxId: null,
			address: null,
			phone: null,
			customerCode: null,
			paymentGateway: null,
			itemName: param.itemName,
			itemCode: param.itemCode,
			productId: null,
			typeItem: param.typeItem,
			qty: param.qty,
			itemPrice: param.itemPrice,
			discount: param.discount,
			subscriptionId: param.subscriptionId,
			subscriptionName: param.subscriptionName,
			dateDue: param.dateDue,
			status: param.status,
			statusName: param.statusName,
			dateInvoice: param.dateInvoice,
			itemDescription: param.itemDescription,
			createdByUserId: null,
			type: null,
			url: null,
			vat: null,
			subTotalAfterDiscount: null,
			vatAmount: null,
			totalAmount: param.totalAmount,
			couponCode: null,
			ref1: null,
			ref2: null,
			barcodeNumber: null,
			isIncludeVat: null,
			isPay: param.isPay,
			isForUpgrade: null,
			companyId: null,
			year: null,
			periodCalculateNo: null,
			isAdhoc: null,
			untilDate: null,
			dateCreated: null,
			d365InvoiceNumber: null,
			d365SalesOrderNumber: null,
			d365PackingSlipNumber: null,
			d365ReceiptNumber: null,
			isFutureInvoice: null,
			dateNextBilling: null,
			billingAddressId: null,
			billingAddressPart1: null,
			billingAddressPart2: null,
			billingSubDistrict: null,
			billingDistrict: null,
			billingProvince: null,
			billingZipCode: null,
			groupId: null,
			isBillingCycle: null,
			branchNo: null,
			couponId: null,
			billingInterval: null,
			billEvery: null,
			periodExtendNo: null,
			paymentTransactions: param.paymentTransactions,
			invoiceItems: param.invoiceItems,
		}
	}
}
